<template>
    <div class="tm-scope tm-auth">
        <div class="tm-auth__wrap">
            <div class="tm-card tm-auth__card tm-reveal">
                <img src="../../assets/images/Logo black.png" class="tm-auth__logo" alt="Topment">
                <h3 class="mb-4">Sign in</h3>

                <div class="text-start">
                    <label class="tm-field-label" for="signin-email">Email</label>
                    <input id="signin-email" type="email" class="tm-field mb-3" v-model="email">

                    <label class="tm-field-label" for="signin-password">Password</label>
                    <input id="signin-password" type="password" class="tm-field" v-model="password">

                    <div v-if="error" class="text-danger mt-2" style="font-size: 0.85rem;">{{ error }}</div>
                </div>

                <button class="tm-btn-primary w-100 mt-4" :disabled="loading" @click="signin()">
                    <Spinner v-if="loading" :size="16" />
                    <span v-else>Sign in</span>
                </button>

                <div class="tm-auth__foot">
                    Don't have an account?
                    <a class="tm-auth__link" @click="router.push({'name':'signup'})">Sign up</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { AuthApiService } from '@/services/AuthApiService';
import Spinner from '@/components/Spinner.vue';

export default defineComponent({
    components: {
        Spinner,
    },
    setup() {
        const router = useRouter()
        const route = useRoute()
        const email = ref()
        const password = ref()
        const error = ref()
        const loading = ref(false)

        function signin() {
            if (email.value && password.value) {
                error.value = ''
                loading.value = true
                AuthApiService.signin(email.value,password.value).then((res)=>{
                    if (res.status==200) {
                        localStorage.setItem('user_id',res.data.user_id)
                        localStorage.setItem('user_name',res.data.user_name)
                        localStorage.setItem('auth_token',res.data.token)
                        setTimeout(() => {
                            localStorage.removeItem('user_id')
                            localStorage.removeItem('auth_token')
                        }, 7200000);
                        // Back to the page that asked for sign-in (internal paths only).
                        const back = route.query.redirect
                        router.push(typeof back === 'string' && back.startsWith('/') && !back.startsWith('//') ? back : { name: 'landing-page' })
                    }
                }).catch((err)=>{
                    if (err.status==404) {
                        error.value = 'Email not found'
                    }
                    else if (err.status==401) {
                        error.value = 'Password is wrong'
                    }
                    else {
                        error.value = 'Something went wrong. Please try again.'
                    }
                }).finally(()=>{
                    loading.value = false
                })
            }
            else {
                error.value = 'Please fill in all the values'
            }
        }

        return {
            router,
            email,
            password,
            error,
            loading,
            signin,
        }
    },
})
</script>
<style lang="scss" scoped>
.tm-auth {
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.tm-auth__wrap {
    width: 100%;
    max-width: 400px;
}

.tm-auth__card {
    text-align: center;
    padding: 40px;
}

.tm-auth__logo {
    width: 120px;
    margin: 0 auto 24px;
    display: block;
}




.tm-auth__foot {
    margin-top: 20px;
    font-size: 0.88rem;
    color: var(--tm-ink-muted);
}

.tm-auth__link {
    color: var(--tm-ink);
    font-weight: 500;
    cursor: pointer;
    text-decoration: underline;
}
</style>
